<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 12C8.55228 12 9 12.4477 9 13V15.5C9 17.9853 11.0147 20 13.5 20C15.9853 20 18 17.9853 18 15.5V14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14V15.5C20 19.0899 17.0899 22 13.5 22C9.91015 22 7 19.0899 7 15.5V13C7 12.4477 7.44772 12 8 12Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.66667 4C4.29848 4 4 4.29848 4 4.66667V8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8V4.66667C12 4.29848 11.7015 4 11.3333 4H11C10.4477 4 10 3.55228 10 3C10 2.44772 10.4477 2 11 2H11.3333C12.8061 2 14 3.19391 14 4.66667V8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8V4.66667C2 3.19391 3.19391 2 4.66667 2H5C5.55228 2 6 2.44772 6 3C6 3.55228 5.55228 4 5 4H4.66667Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13ZM19 15C20.6569 15 22 13.6569 22 12C22 10.3431 20.6569 9 19 9C17.3431 9 16 10.3431 16 12C16 13.6569 17.3431 15 19 15Z"
    fill="currentColor"
  />
</svg>
